import type { Locale } from "date-fns";
import {
    de as deLocale,
    enGB as enLocale,
    sv as svLocale,
} from "date-fns/locale";
import type { LanguageCode } from "../translations/language-code";

const getLocale = (languageCode: LanguageCode): Locale => {
    switch (languageCode) {
        case "sv":
            return svLocale;
        case "en":
            return enLocale;
        case "de":
            return deLocale;
        default:
            // eslint-disable-next-line no-console
            console.error(
                `Unimplemented language code locale in getLocale; ${languageCode || "undefined"}`,
            );
            return enLocale;
    }
};

// todo, switch to dynamic imports?

export { getLocale };
